import { useQuery } from "@tanstack/react-query";
import { pppService } from "@/services/pppService";
import { PppFilter } from "@/types";

/** PPP lists are small and unpaginated in the UI; one page (server cap) covers them all. ponytail: /ppp disables ranking if `total` exceeds this. */
export const PPP_LIST_LIMIT = 500;

export const RANKED_PPP_PARAMS = { limit: PPP_LIST_LIMIT, sortBy: "orderIndex", sortOrder: "ASC" } as const;

export const usePpps = (params?: PppFilter, enabled = true) =>
  useQuery({
    queryKey: ["ppps", params],
    queryFn: () => pppService.getPpps(params),
    enabled,
  });

export const usePppsByKr = (keyResultPid?: string) =>
  useQuery({
    queryKey: ["ppps", { keyResultPid }],
    queryFn: () => pppService.getPpps({ ...RANKED_PPP_PARAMS, keyResultPid }),
    enabled: !!keyResultPid,
    staleTime: 30_000,
  });
